import { render, staticRenderFns } from "./setDiagnosis.vue?vue&type=template&id=45ad559c&scoped=true&"
import script from "./setDiagnosis.vue?vue&type=script&lang=js&"
export * from "./setDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./setDiagnosis.vue?vue&type=style&index=0&id=45ad559c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ad559c",
  null
  
)

export default component.exports